import React from 'react'
import { useMediaQuery, useTheme } from '@material-ui/core'
import {
  Box,
} from '@material-ui/core'
import Text from './Text'
import List from './List'
import useStyles from './styles'
import Button from './Button'

export const Section = ({ variant, children, ...props}) => {
  const classes = useStyles()
  
  // titleTextCustomProps (optional): style merged onto the title text, e.g. { fontWeight: 400 } for a plain-weight title
  const {title, titleButtons, gutterBottom, onTitleClick, compactTitle = false, titleTextCustomProps} = props

  const content = React.Children.map(children, e => {
    // Add custom wrapper to enable full bleed inside panel
    // to some known element. We should do this in CSS using 
    // nested selected, but don't know how to do this in material-ui yet
    if (React.isValidElement(e)) {
      if (e.type == List)
        return (<div className={classes.panelList}>{e}</div>)
    }
    
    return e
  })  
  
  return (
    <Box mb={gutterBottom ? (variant === 'subsection' ? 2 : 4) : 0}
      className={classes.section}
      >
      {/* titleButtons alone (no title) is a valid header — e.g. an icon-only "+"
          action with no section heading — so this can't stay gated on `title` alone;
          every existing caller that sets titleButtons already sets a title too, so
          this widening doesn't change anything for them. */}
      {(title || (titleButtons && titleButtons.length > 0)) &&
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className={variant === 'subsection' ? classes.subsectionHeader : classes.sectionHeader}>
          {/* minWidth:0 on the title (a flex item defaults to min-width:auto, i.e. its
              own natural text width) + overflow/ellipsis, and flexShrink:0 on the
              buttons row — without this, a long title next to more than one
              titleButton (e.g. an existing "+" plus a newly-added collapse toggle) can
              together exceed the header's available width and silently overflow past
              the Section's own bounds in a narrow column instead of the title
              truncating gracefully; the buttons themselves never shrink/wrap.
              onTitleClick (optional) — makes the title text itself, not just a
              titleButton, a click target (e.g. for a collapsible section's own
              expand/collapse toggle) — opt-in, no-op for every other caller. */}
          <Text
            component={variant === 'subsection' ? 'h5' : 'h4'}
            className={variant === 'subsection' ? classes.subsectionTitleText : (compactTitle ? classes.sectionTitleTextCompact : classes.sectionTitleText)}
            onClick={onTitleClick}
            textCustomProps={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: onTitleClick ? 'pointer' : undefined, ...titleTextCustomProps }}>
            {title}
          </Text>
          <Box display="flex" flexShrink={0}>
            {titleButtons && titleButtons?.map(button => (
              <Button {...button}
                onClick={(event) => { event.stopPropagation(); button.onClick(event); }}
              />
            ))}
          </Box>
        </Box>
      }
      {content}
      {/*
      <Box mt={variant === 'subsection' ? 1 : 2} mb={variant === 'subsection' ? 1 : 2}>
        { children }
      </Box>
      */}
    </Box>
  )
}

export default Section